import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from '../../core/interfaces/cell-renderer.interface';

/**
 * Reference Cell Renderer Component
 *
 * Renders combined reference and additionalOC fields.
 * Displays "reference - additionalOC" or either field if one is missing.
 *
 * Features:
 * - Combines reference and additionalOC fields with " - " separator
 * - Shows only available field if one is missing
 * - Falls back to "-" if both are null/undefined
 *
 * Usage in ColDef:
 * ```typescript
 * {
 *   colId: 'additionalOC',
 *   headerName: 'Referencia',
 *   cellRenderer: ReferenceCellRendererComponent,
 *   sortable: true,
 *   valueGetter: (row) => row.reference || row.additionalOC
 * }
 * ```
 *
 * Output examples:
 * - "REF123 - OC456"
 * - "REF123"
 * - "OC456"
 */
@Component({
  selector: 'app-reference-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-content">
      {{ referenceDisplay }}
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferenceCellRendererComponent implements CellRenderer<any, any> {
  /**
   * Parameters from the grid containing the cell value and row data
   */
  @Input() params!: CellRendererParams<any, any>;

  /**
   * Get formatted reference display
   */
  get referenceDisplay(): string {
    const data = this.params?.data;
    if (!data) return '-';
    
    const additionalOC = data.additionalOC;
    

    return additionalOC || '-';
  }
}
